import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Hero from '../components/Hero';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Seo from '../components/SEO/PageSeo';
export const _frontmatter = {
  "title": "About Us"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Layout mdxType="Layout">
  <Seo mdxType="Seo" />
  <Hero mdxType="Hero" />
    <section>
      <div className="page-center text-center">
          <h1>{`The Housing Situation`}</h1>
          <div className="underline"></div>
          <div className="posts-center">
            <article>
We live in an area that is - let's face it - ugly. It's an old
industrial region which has been on the decline for the last 20
years. It is far away from the sea, mountains, or pristine nature.
              <h2>{`Concrete Jungle`}</h2>
              <p>{`Instead we are surrounded by concrete cities, clogged up highways
and gray skies. How did we even end up here? House prices are
unreasonable high. For the price of a flat we could buy a house with
a garden (and did once) where we used to live.`}</p>
              <h2>{`Do what we love`}</h2>
              <p>{`We started looking for
houses in an area we already lived in, and actually love: La
Gironde, France.`}</p>
              <p>{`With Corona and home-office we thought:`}</p>
              <blockquote>
                <p parentName="blockquote"><strong parentName="p">{`Ok, we live in Germany. Why not buy a house in France?`}</strong></p>
              </blockquote>
              <h3>{`Two scenarios`}</h3>
              <p>{`From todays perspective the worst case scenario seems to be:`}</p>
              <ul>
                <li parentName="ul">{`we will have a house for our holidays in a beautiful area - and for our
retirement.`}</li>
                <li parentName="ul">{`For the best of cases, we would have a house to live in.`}</li>
              </ul>
              <blockquote>
                <p parentName="blockquote">{`In any case, that seems pretty awesome to us.`}</p>
              </blockquote>
              <h4>{`Finding a house`}</h4>
              <p>{`In February 2021 we started out looking for houses in proximity to
our old surf-spot Carcans Plage.`}</p>
              <ul>
                <li parentName="ul">{`Of the 10-15 houses we visited,
none where to our liking. Not because they were not beautiful but
because they were either`}
                  <ul parentName="li">
                    <li parentName="ul">{`build upon a swamp or`}</li>
                    <li parentName="ul">{`not built with thequality we would expect.`}</li>
                  </ul>
                </li>
              </ul>
              <p>{`Many people build cheap houses of cheap quality to sell it for cheap. We want a house that
lasts a long time, so we thought:`}</p>
              <h2>{`Why not build a house?`}</h2>
              <p>{`Very well, why not build a house and have it constructed the way we
would appreciate it? There are many reasons why building a house can
be great.`}</p>
              <h4>{`Building a dream house`}</h4>
              <p>{`Hopefully, you get your dream house, with the layout you
want, the colors you like. And it's all new and shiny. But building
a house is also a lot of stress and there is a lot you need to be
aware of and this is what this blog is about.`}</p>
              <h3>{`This blog is about`}</h3>
              <p><strong parentName="p">{`Building a house in France while living Germany.`}</strong></p>
              <p>{`We will present here all the different steps of building a
house, starting with the terrain, the bank credit, all the
administrative formalities and all the building steps. We will post
insider infos and photos during all the project, until our house is
finished. We chose the construction company MCA, follow us and get
insider information on how everything went.`}</p>
            </article>
            <article>
  <Banner mdxType="Banner" />
            </article>
          </div>
        </div>
      </section>
    </Layout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      